import React from "react";
import ButtonEdit from "../../../../components/Button/ButtonEdit";
import ButtonDelete from "../../../../components/Button/ButtonDelete";
import { InlineRoleSelect } from "./InlineRoleSelect";
import { RoleBadge } from "./RoleBadge";

export function UsersTable({
  data,
  onEdit,
  onDelete,
  onInlineRole,
  roleById,
  fmtDate,
  roles,
  clubNames,
}) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left text-sm min-w-[900px]">
        <thead className="bg-slate-50 dark:bg-slate-800/60">
          <tr>
            <Th>Date</Th>
            <Th>Nom / Prénom</Th>
            <Th>Email</Th>
            <Th>Rôle</Th>
            <Th>Club</Th>
            <Th>Actions</Th>
          </tr>
        </thead>
        <tbody>
          {data.map((u) => {
            const role = roleById.get(u.role_id);
            const clubId = u?.Club?.id ?? u?.club_id;
            const clubLabel =
              u?.Club?.nom_club ||
              (clubId ? clubNames.get(clubId) : null) ||
              "—";

            return (
              <tr
                key={u.id}
                className="border-b border-slate-100 dark:border-slate-800"
              >
                <Td>{fmtDate(u.createdOn)}</Td>
                <Td className="font-medium">
                  {u.nom} {u.prenom}
                </Td>
                <Td>{u.email}</Td>
                <Td>
                  <div className="flex items-center gap-2">
                    <RoleBadge tone={role?.badge}>
                      {role?.label || "Non affecté"}
                    </RoleBadge>
                    <InlineRoleSelect
                      value={u.role_id}
                      options={roles}
                      onChange={(v) => onInlineRole(u, v)}
                      size="sm"
                    />
                  </div>
                </Td>
                <Td>
                  {clubLabel}
                  {u?.Club?.departement_club
                    ? ` (${u.Club.departement_club})`
                    : ""}
                </Td>
                <Td>
                  <div className="flex gap-2">
                    <ButtonEdit onClick={() => onEdit(u)} />
                    <ButtonDelete onClick={() => onDelete(u.id)} />
                  </div>
                </Td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function Th({ children }) {
  return (
    <th className="py-3 px-4 text-left text-slate-600 dark:text-slate-300">
      {children}
    </th>
  );
}

function Td({ children, className = "" }) {
  return <td className={`py-3 px-4 align-top ${className}`}>{children}</td>;
}